import React from 'react';

import { Button, Col, Form, Input, Row } from 'antd';

import { getCommonRoutePath } from './Helpers';
import { localStorageWrapper } from './storageFactory';

import { AUTH_BY_EXTERNAL_SPEAKER_CODE, LOGIN_SUCCESS, getAccountInfo } from '../redux/actions/accountActions';
import { CLOSE_ACTION_MODAL_CHILD, OPEN_ACTION_MODAL_CHILD } from '../redux/actions/componentsActions';
import store from '../redux/store';

export const authBySpeakerCode = (speakerAuthCode, navigate, slug, universityLinkSlug) => {
    const speakerDataRequred = new URL(window.location.href).searchParams.get('dataRequired');
    const isSpeakerDataAnswered = localStorageWrapper.getItem('speakerInfoAnswered');
    const isUniversityLink = !!universityLinkSlug;

    if (speakerDataRequred === 'true' && !isSpeakerDataAnswered) {
        store.dispatch({
            type: OPEN_ACTION_MODAL_CHILD,
            payload: {
                children: (
                    <ModalContent
                        speakerAuthCode={speakerAuthCode}
                        slug={slug}
                        navigate={navigate}
                        isUniversityLink={isUniversityLink}
                    />
                ),
                openOnMaskClick: true,
                positionAbsolute: true,
            },
        });
    } else {
        handleAuth({ speakerAuthCode, slug, navigate, isUniversityLink });
    }
};

const handleAuth = ({ speakerAuthCode, slug, firstName, lastName, navigate, isUniversityLink }) => {
    const onSuccess = (token) => {
        store.dispatch({
            type: LOGIN_SUCCESS,
            payload: {
                token: token,
                isLoading: true,
            },
        });

        localStorageWrapper.setItem('TapAccountInteractionSite', JSON.stringify(token));

        store.dispatch(getAccountInfo());
        store.dispatch({
            type: CLOSE_ACTION_MODAL_CHILD,
        });

        if (isUniversityLink) {
            navigate(`${getCommonRoutePath()}/live-streams/${slug}`);
        }
    };

    const onFail = () => {
        store.dispatch({
            type: OPEN_ACTION_MODAL_CHILD,
            payload: {
                children: <ModalContentOnFail />,
            },
        });
    };

    const requestData = {
        speakerAuthCode,
    };

    if (firstName && lastName) {
        requestData.name = firstName;
        requestData.lastName = lastName;
    }
    store.dispatch({
        type: AUTH_BY_EXTERNAL_SPEAKER_CODE,
        payload: {
            slug,
            requestData,
        },
        onSuccess: onSuccess,
        onFail: onFail,
    });
};

const ModalContent = ({ speakerAuthCode, slug, navigate, isUniversityLink }) => {
    const slugArr = slug.split('-');
    const eventName = slugArr.slice(0, slugArr.length - 5).join(' ');

    const processAuth = (values) => {
        handleAuth({
            speakerAuthCode,
            slug,
            firstName: values.first_name,
            lastName: values.last_name,
            navigate,
            isUniversityLink,
        });
        localStorageWrapper.setItem('speakerInfoAnswered', JSON.stringify(true));
    };

    return (
        <Col className="general-popup">
            <Row className="speaker-modal-title">
                Join the stream {eventName ? <span className="capitalize">&apos;{eventName}&apos;</span> : null}
            </Row>
            <Form
                layout="vertical"
                initialValues={{
                    first_name: '',
                    last_name: '',
                }}
                onFinish={processAuth}
                autoComplete="off"
                hideRequiredMark
            >
                <Form.Item
                    name="first_name"
                    label="First name"
                    className="form-input"
                    rules={[
                        { required: true, message: 'Add first name' },
                        ({ getFieldValue }) => ({
                            validator() {
                                const firstNameValue = getFieldValue('first_name');
                                if (firstNameValue && firstNameValue.length < 2) {
                                    return Promise.reject(new Error('First name should contain at least 2 symbols'));
                                }
                                return Promise.resolve();
                            },
                        }),
                    ]}
                >
                    <Row style={{ flexFlow: 'nowrap' }}>
                        <Input placeholder="First name" maxLength={50} />
                    </Row>
                </Form.Item>
                <Form.Item
                    name="last_name"
                    label="Last name"
                    className="form-input"
                    rules={[
                        { required: true, message: 'Add last name' },
                        ({ getFieldValue }) => ({
                            validator() {
                                const lastNameValue = getFieldValue('last_name');
                                if (lastNameValue && lastNameValue.length < 2) {
                                    return Promise.reject(new Error('Last name should contain at least 2 symbols'));
                                }
                                return Promise.resolve();
                            },
                        }),
                    ]}
                >
                    <Input placeholder="Last name" />
                </Form.Item>
                <Button
                    className="sign-up-sbm register-external-speaker"
                    id="button-register-account"
                    htmlType="submit"
                >
                    Next
                </Button>
            </Form>
        </Col>
    );
};

const ModalContentOnFail = () => {
    const closeModal = () => {
        store.dispatch({
            type: CLOSE_ACTION_MODAL_CHILD,
        });
    };
    return (
        <div className="general-popup" id="verification">
            <h2 className="modal-title">Oops!</h2>
            <div className="sub-title">The page you&apos;re looking for doesn&apos;t exist</div>
            <button type="submit" className="el-btn general-action-button cancel" onClick={closeModal}>
                OK
            </button>
        </div>
    );
};

export const ModalContentOnMobileAuth = () => {
    const closeModal = () => {
        store.dispatch({
            type: CLOSE_ACTION_MODAL_CHILD,
        });
    };
    return (
        <div className="general-popup" id="verification">
            <div className="sub-title">
                You may join as a viewer and access chat on a mobile device. Please, use a desktop browser if you are a
                speaker and need to use the camera and microphone.
            </div>
            <button type="submit" className="el-btn general-action-button cancel" onClick={closeModal}>
                OK
            </button>
        </div>
    );
};
